import { SxProps } from "@mui/material";

export const LoadingContainer: SxProps = {
  display: "flex",
  justifyContent: "center",
  mt: "15%",
};
